import getLocaleLink from './getLocaleLink';

import type { Locale } from '../i18n/language';

interface GetSocialsProps {
  title: string;
  description: string;
  locale: Locale;
  page?: string;
  ogType?: string;
}

export default function getSocials({
  title, description, locale, page, ogType = 'website',
}: GetSocialsProps):
  React.DetailedHTMLProps<React.MetaHTMLAttributes<HTMLMetaElement>, HTMLMetaElement>[] {
  return [
    {
      title,
    },
    {
      name: 'description',
      content: description,
    },
    // Open Graph metadata
    {
      property: 'og:title',
      content: title,
    },
    {
      property: 'og:description',
      content: description,
    },
    {
      property: 'og:type',
      content: ogType,
    },
    {
      property: 'og:url',
      content: getLocaleLink({ page, locale }),
    },
    {
      property: 'og:site_name',
      content: 'Stefan Studios',
    },
    {
      property: 'og:locale',
      content: locale,
    },
    {
      property: 'og:image',
      content: 'https://stefan-studios.nl/favicon-512x512.png',
    },
    // Twitter metadata
    {
      name: 'twitter:card',
      content: 'summary_large_image',
    },
    {
      name: 'twitter:title',
      content: title,
    },
    {
      name: 'twitter:description',
      content: description,
    },
  ];
}
